var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-entity-info',{attrs:{"imageUrl":_vm.entity.logo,"imageBorderRadius":"50%","imageHasBorder":true},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [(_vm.hasPremiumBadge)?_c('ez-premium-badge'):_vm._e()]},proxy:true}])},[_c('span',{attrs:{"data-cy":_vm.dataCy}},[_vm._v(_vm._s(_vm.entity.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }